<template>
    <div class="profile-progress-dashboard">
        <design-2021-vso-profile-progress-component
            v-if="profileSettingsIn && profileSettingsIn.vso_style"
            :user-credentials-in="userCredentialsIn"
            :teacher-access="teacherAccess"
            :timeline-items-in="cardsIn"
            :categories-in="categoriesIn"
            :seasons-in="seasonsIn"
            :skill-trees-in="skillTreesIn"
            :vso-skill-tree-in="vsoSkillTreeIn"
            :personal-goals-in="personalGoalsIn"
            :gradable-moments-in="gradableMomentsIn"
            :student-evaluations-in="studentEvaluationsIn">
        </design-2021-vso-profile-progress-component>

        <design-2021-default-profile-progress-component
            v-else
            :cards-in="cardsIn"
            :categories-in="categoriesIn"
            :user-credentials-in="userCredentialsIn"
            :teacher-access="teacherAccess"
            :seasons-in="seasonsIn"
            :skill-trees-in="skillTreesIn"
            :personal-goals-in="personalGoalsIn"
            :badges-in="badgesIn"
            :modules-in="modulesIn"
            :module-users-in="moduleUsersIn"
            :available-school-skill-trees-in="availableSchoolSkillTreesIn"
            :has-modules-in="hasModulesIn"
            :banner-in="bannerIn"
            :test-responses-in="testResponsesIn">
        </design-2021-default-profile-progress-component>
    </div>
</template>
<script>
export default {
    name: 'design-2021-profile-progress-component',
    props: {
        cardsIn: Array,
        categoriesIn: Array,
        userCredentialsIn: Object,
        modulesIn: Array,
        moduleUsersIn: Array,
        personalGoalsIn: Array,
        teacherAccess: Boolean,
        skillTreesIn: Array,
        availableSchoolSkillTreesIn: Array,
        hasModulesIn: Boolean,
        bannerIn: Object,
        seasonsIn: Array,
        badgesIn: Array,
        profileSettingsIn: Object,
        vsoSkillTreeIn: {
            type: Object,
            required: false,
        },
        gradableMomentsIn: {
            type: Array,
            required: false,
            default: [],
        },
        studentEvaluationsIn: {
            type: Array,
            required: false,
            default: [],
        },
        testResponsesIn: {
            type: Array,
            required: false,
        }
    },

    data() {
        return {
            LoggedUSer: this.$authUser,
            // Todo Backend get value from BD
            viewType: 2,
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
